import { render, staticRenderFns } from "./CellTitle.vue?vue&type=template&id=82bb223e&scoped=true"
import script from "./CellTitle.vue?vue&type=script&lang=js"
export * from "./CellTitle.vue?vue&type=script&lang=js"
import style0 from "./CellTitle.vue?vue&type=style&index=0&id=82bb223e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82bb223e",
  null
  
)

export default component.exports